import { render, staticRenderFns } from "./vehicleinspections.html?vue&type=template&id=0b7ac9f8&scoped=true&"
import script from "./vehicleinspections.vue?vue&type=script&lang=js&"
export * from "./vehicleinspections.vue?vue&type=script&lang=js&"
import style0 from "./vehicleinspections.vue?vue&type=style&index=0&id=0b7ac9f8&prod&scoped=true&lang=css&"
import style1 from "./vehicleinspections.vue?vue&type=style&index=1&id=0b7ac9f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ac9f8",
  null
  
)

export default component.exports